/* External */
import { useEffect, useRef } from 'react';

/* Utils */
import { useTitle, getAllGenres } from '../../../utils/metaDataUtils';
import { REPORT_GA } from '../../../utils/constants';
import { gaService } from '../../../services/gaService';

const UNKNOWN = 'unknown';

export default function useAnalytics(isReadyToPlay, content, playSource) {
  const title = useTitle(content);
  const titleRef = useRef(title);

  useEffect(() => {
    titleRef.current = title;
  }, [title]);

  useEffect(() => {
    if (isReadyToPlay && content) {
      gaService.sendEvent({
        action: getAllGenres(content) || UNKNOWN,
        label: titleRef.current,
        category: REPORT_GA.GA_EVENT_CATEGORY_CONTENT,
      }, {
        playSource,
        sourceProvider: content?.sourceProvider,
      });
    }
  }, [content, isReadyToPlay, playSource]);
}
